module.exports = __webpack_public_path__ + "img/hk_room_floorplan_02_en.78e3386f.png";